import * as React from 'react';
import { ProductInterface } from '../../Model/Product';
import { CalculatorLink } from '../CalculatorLink';
import { FinderDownload } from './FinderDownload';

interface MiscCellProps {
    product: ProductInterface
    datasheetAttr?: string
    datasheetTitle?: string
    manualAttr?: string
    manualTitle?: string
    dataAcquisitionAttr?: string
    dataAcquisitionTitle?: string
    dataAcquisitionRotatingAttr?: string
    dataAcquisitionRotatingTitle?: string
    installationInstructionAttr?: string
    installationInstructionTitle?: string
    calculator?: boolean
}

export class MiscCell extends React.Component<MiscCellProps, {}> {
    public render() {
        const props = this.props;
        const product = props.product;
        const datasheetAttr = props.datasheetAttr || 'Datenblatt';
        const datasheetTitle = props.datasheetTitle || 'Datenblatt';
        const manualAttr = props.manualAttr || 'Bedienungsanleitung';
        const manualTitle = props.manualTitle || 'Bedienungsanleitung';
        const dataAcquisitionAttr = props.dataAcquisitionAttr || 'Datenerfassungsformular';
        const dataAcquisitionTitle = props.dataAcquisitionTitle || 'Datenerfassung';
        const dataAcquisitionRotatingAttr = props.dataAcquisitionRotatingAttr || 'Datenerfassungsformular_rotierend';
        const dataAcquisitionRotatingTitle = props.dataAcquisitionRotatingTitle || 'Datenerfassung_rotierend';

        const installationInstructionAttr = props.installationInstructionAttr;
        const installationInstructionTitle = props.installationInstructionTitle;

        return <td>
            <FinderDownload product={product} attr={datasheetAttr} title={datasheetTitle}/>
            <FinderDownload product={product} attr={dataAcquisitionAttr} title={dataAcquisitionTitle} download={true}/>
            <FinderDownload product={product}
                            attr={dataAcquisitionRotatingAttr}
                            title={dataAcquisitionRotatingTitle}
                            download={true}/>
            <FinderDownload product={product} attr={manualAttr} title={manualTitle}/>
            {installationInstructionAttr ? <FinderDownload product={product}
                                                           attr={installationInstructionAttr}
                                                           title={installationInstructionTitle}/> : null}
            {props.calculator ? <CalculatorLink product={product}/> : null}
        </td>;
    }
}
